import { FC } from 'react'
import makeStyles from '@mui/styles/makeStyles';
import { Paper, PaperProps } from '@mui/material';

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(4),
        borderRadius: theme.deloitte.radius,
        flexGrow: 1
    },
    rootFullHeight: {
        padding: theme.spacing(4),
        height: '100%',
        borderRadius: theme.deloitte.radius,
        flexGrow: 1
    }
}));

interface DeloittePaperProps extends PaperProps {
    fullHeight?: boolean;
}

export const DeloittePaper: FC<DeloittePaperProps> = (props) => {
    const classes = useStyles();
    const { fullHeight, ...otherProps } = props;
    return <Paper id="test" className={props.fullHeight ? classes.rootFullHeight : classes.root} {...otherProps} />
}